import { render, staticRenderFns } from "./hospitalApproval.vue?vue&type=template&id=58e0df23&scoped=true&"
import script from "./hospitalApproval.vue?vue&type=script&lang=js&"
export * from "./hospitalApproval.vue?vue&type=script&lang=js&"
import style0 from "./hospitalApproval.vue?vue&type=style&index=0&id=58e0df23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e0df23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VDialog,VRow})
